// PUT ADS
export const PUT_ADS_REQUEST = 'PUT_ADS_REQUEST';
export const PUT_ADS_SUCCESS = 'PUT_ADS_SUCCESS';
export const PUT_ADS_FAILURE = 'PUT_ADS_FAILURE';
